import { useRef } from 'react'

const useMoveScroll = (banner2Ref: React.RefObject<HTMLImageElement>) => {
  const RefInput = useRef<any>(null)
  const onMoveToElement = () => {
    banner2Ref.current?.scrollIntoView({ behavior: 'smooth', block: 'start' })
    setTimeout(() => {
      RefInput.current.focus()
    }, 500)
  }
  return { RefInput, onMoveToElement }
}

export default useMoveScroll
